import { useTranslation } from 'react-i18next';
import { PickersRangeCalendarHeaderProps } from '@mui/x-date-pickers-pro/PickersRangeCalendarHeader';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import { DateRange, LocalizationProvider, StaticDateRangePicker } from '@mui/x-date-pickers-pro';
import { startOfDay, endOfDay } from 'date-fns';

import { getLocale, translate } from '@/components/common/translateFunctions';
import { CustomCalendarHeader } from './CustomCalendarHeader';
import { localeText, shortcutsItems } from './DateRangeSelectBase';
import { isValidDate } from '@/utilities/dateUtils';

export function StaticDateRangeSelect({ setSelectedDates }: { setSelectedDates: (from: Date, to: Date) => void }) {
  const { t, i18n } = useTranslation();
  const locale = getLocale(i18n.language);
  const MINDATE = new Date('2010-01-01T00:00:00Z');

  function onChange(newValue: DateRange<Date>) {
    // csak akkor küldjük kifelé, ha mindkét dátum megvan és valid
    if (!newValue[0] || !newValue[1]) return;
    if (!isValidDate(newValue[0]) || !isValidDate(newValue[1])) return;

    setSelectedDates(startOfDay(newValue[0]), endOfDay(newValue[1]));
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
      <StaticDateRangePicker
        className="mui-datetime-selector"
        onChange={onChange}
        // defaultValue={[currentValue.from, currentValue.to]}
        disableFuture
        minDate={MINDATE}
        slots={{
          calendarHeader: CustomCalendarHeader,
        }}
        slotProps={{
          actionBar: {
            actions: [],
          },
          shortcuts: {
            id: 'shortcuts_panel',
            items: translate(shortcutsItems, t),
            sx: {
              '.MuiList-root': {
                margin: '0px',
              },
              '& .MuiListItem-root:nth-of-type(2) .MuiChip-root, & .MuiListItem-root:nth-of-type(3) .MuiChip-root': {
                border: 1,
                borderColor: 'secondary.main',
              },
              '& .MuiListItem-root:nth-of-type(4) .MuiChip-root, & .MuiListItem-root:nth-of-type(5) .MuiChip-root': {
                border: 1,
                borderColor: 'primary.main',
                color: 'primary.main',
              },
              '& .MuiChip-root': {
                border: 1,
              },
            },
          },
          toolbar: {
            hidden: true,
          },
          day: (ownerState) => {
            const d = ownerState.day;
            const formatted = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
            return { id: `day_of_month_${formatted}` };
          },
          calendarHeader: {
            maxDate: new Date(),
          } as Partial<PickersRangeCalendarHeaderProps>,
        }}
        localeText={localeText(t)}
      />
    </LocalizationProvider>
  );
}
